import clsx from 'clsx';

export const ActionButton = ({ text, type = 'button', loading = false, className, onClick }) => {
  return (
    <button
      disabled={loading}
      type={type}
      onClick={onClick}
      className={clsx(
        'flex items-center justify-center rounded-[4px] border-none bg-action py-2 px-0 !px-3 font-semibold normal-case text-primary transition-colors hover:bg-action disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        className="block px-0 xmd:hidden"
      >
        <rect width="36" height="36" rx="2" fill="none" />
        <path
          d="M24.8763 10.1009L10.3904 18.4555C9.82467 18.7804 9.89655 19.5678 10.4591 19.8052L13.7813 21.1987L22.7604 13.2878C22.9323 13.1347 23.1761 13.369 23.0292 13.5471L15.5003 22.7172V25.2323C15.5003 25.9696 16.391 26.2602 16.8285 25.7259L18.8131 23.3108L22.7073 24.9417C23.1511 25.1292 23.6574 24.8511 23.7387 24.3731L25.9889 10.8758C26.0952 10.2447 25.417 9.7885 24.8763 10.1009Z"
          fill="white"
        />
      </svg>
      <span className="button-text hidden px-0 xmd:block">{text}</span>
    </button>
  );
};
